var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "ds-icon-btn",
      class: { "ds-icon-btn--active": _vm.active },
      attrs: { type: "button", "aria-label": _vm.label },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c("ds-icon", {
        attrs: { name: _vm.icon, size: _vm.size, filled: _vm.filled },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }